export const WORK_AGE = {
  NEW: 'NEW',
  EXISTING: 'EXISTING',
};

export const WORK_CATEGORY = {
  ALLIED: 'ALLIED',
  BUILDING: 'BUILDING',
  ALLIED_BUILDING: 'ALLIED_BUILDING',
};

export const WORK_CATEGORY_MAP = {
  'Allied Work': WORK_CATEGORY.ALLIED,
  'Building Work': WORK_CATEGORY.BUILDING,
  'Allied + Building Work': WORK_CATEGORY.ALLIED_BUILDING,
};

export const WORK_CATEGORY_LABELS = {
  [WORK_CATEGORY.ALLIED]: 'Allied Work',
  [WORK_CATEGORY.BUILDING]: 'Building Work',
  [WORK_CATEGORY.ALLIED_BUILDING]: 'Allied + Building Work',
};

export const WORK_AGE_MAP = {
  'New Job': WORK_AGE.NEW,
  'Existing Job': WORK_AGE.EXISTING,
};

export const WORK_AGE_LABELS = {
  [WORK_AGE.NEW]: 'New Work',
  [WORK_AGE.EXISTING]: 'Existing Work',
};

export const TASK_STATUS = {
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED: 'SUBMITTED',
  COMPLETED: 'COMPLETED',
  APPROVED: 'APPROVED',
  REVISION_REQUESTED: 'REVISION_REQUESTED',
};

export const BUILDING_TYPE_OPTIONS = [
  { label: 'Residential Building', value: 'RESIDENTIAL' },
  { label: 'Commercial Building', value: 'COMMERCIAL' },
  {
    label: 'Residential & Commercial Building',
    value: 'RESIDENTIAL_COMMERCIAL',
  },
  { label: 'Industrial Building', value: 'INDUSTRIAL' },
  { label: 'Factory Shed', value: 'FACTORY_SHED' },
  { label: 'Institutional/School Building', value: 'INSTITUTIONAL' },
  { label: 'Hospital Building', value: 'HOSPITAL' },
  { label: 'Mangal Karyalay', value: 'MANGAL_KARYALAY' },
  { label: 'Bungalow', value: 'BUNGALOW' },
  { label: 'Row House', value: 'ROW_HOUSE' },
  { label: 'Farm House', value: 'FARM_HOUSE' },
  { label: 'Club House', value: 'CLUB_HOUSE' },
  { label: 'Retaining Wall', value: 'RETAINING_WALL' },
  { label: 'Compound Wall', value: 'COMPOUND_WALL' },
  { label: 'Swimming Tank', value: 'SWIMMING_TANK' },
  { label: 'Entrance Gate', value: 'ENTRANCE_GATE' },
  { label: 'Hotel Building', value: 'HOTEL' },
  { label: 'Restaurant Building', value: 'RESTAURANT' },
  { label: 'Road & Culverts', value: 'ROAD_CULVERTS' },
  { label: 'Others', value: 'OTHERS' },
];

export const BUILDING_TYPE_LABELS = {
  RESIDENTIAL: 'Residential Building',
  COMMERCIAL: 'Commercial Building',
  RESIDENTIAL_COMMERCIAL: 'Residential & Commercial Building',
  INDUSTRIAL: 'Industrial Building',
  FACTORY_SHED: 'Factory Shed',
  INSTITUTIONAL: 'Institutional/School Building',
  HOSPITAL: 'Hospital Building',
  MANGAL_KARYALAY: 'Mangal Karyalay',
  BUNGALOW: 'Bungalow',
  ROW_HOUSE: 'Row House',
  FARM_HOUSE: 'Farm House',
  CLUB_HOUSE: 'Club House',
  RETAINING_WALL: 'Retaining Wall',
  COMPOUND_WALL: 'Compound Wall',
  SWIMMING_TANK: 'Swimming Tank',
  ENTRANCE_GATE: 'Entrance Gate',
  HOTEL: 'Hotel Building',
  RESTAURANT: 'Restaurant Building',
  ROAD_CULVERTS: 'Road & Culverts',
};
